export default [
    {
        path: "/admin/job-levels",
        name: "job-level",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/job-level")
    }
];
